window.UpdateHealthContactForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            messages: {
                invalidMobileNumber: '#invalid-mobile-number',
                invalidWorkNumber: '#invalid-work-number',
                invalidHomeNumber: '#invalid-home-number'
            },
            textBox: {
                mobileNumber: '#health-telephone-mobile-number',
                workNumber: '#health-telephone-work-number',
                homeNumber:'#health-telephone-home-number',
                mobileNumberErrorMessage:'#mobileNumberErrorMessage',
                homeNumberErrorMessage:'#homeNumberErrorMessage',
                workNumberErrorMessage:'#workNumberErrorMessage'
            }
        },
        css: {
            invalidFormInput: 'vds-form__input--invalid',
            hideElement:'vds-hide'
        },
        urls: {
            sendFormDataUrl: '/api/sitecore/UpdateContactDetails/UpdateMemberContactNumberDetails',
            personalDetailsPageUrl: '/my-account/details',
            errorPageUrl: '/error/error-page'
        },
        constants: {
            NoUpdateMessageCode: 'NoUpdate',
            ValidSurnameMessageCode: 'ValidSurname',
            CharCodeUnitSeparator: 31,
            CharCodeNumericLowerBound: 48,
            CharCodeNumericUpperBound: 57,
            InputNumberLength:11
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $('#health-telephone-form').on('submit', self.func.handleSaveContactNumber);
                $(self.elements.textBox.mobileNumber + ',' + self.elements.textBox.workNumber + ','
                    + self.elements.textBox.homeNumber).on('input', self.func.onInputClearError);
                $(self.elements.textBox.mobileNumber + ',' + self.elements.textBox.workNumber + ','
                    + self.elements.textBox.homeNumber).on('keypress', self.func.allowNumbersOnly);
                $(self.elements.textBox.mobileNumber + ',' + self.elements.textBox.workNumber + ','
                    + self.elements.textBox.homeNumber).on('paste', self.func.allowPastingOfNumbers);
            },
            handleSaveContactNumber: function (event) {
                event.preventDefault();
                if(!self.func.validateInputNumberFields()) {
                    return;
                }
                const contactNumbers = {
                    MobileNumber: $(self.elements.textBox.mobileNumber).val().trim(),
                    HomeNumber: $(self.elements.textBox.homeNumber).val().trim(),
                    WorkNumber: $(self.elements.textBox.workNumber).val().trim()
                };
                $.ajax({
                    type: 'POST',
                    url: self.urls.sendFormDataUrl,
                    data: contactNumbers,
                    success: function(response) {
                        const isAccepted = response.statusCode?.toLowerCase() === self.statusDescription.accepted;
                        window.location.href = isAccepted ? self.urls.personalDetailsPageUrl : self.urls.errorPageUrl;
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            validateInputNumberFields: function () {
                const fields = [
                    { value: $(self.elements.textBox.mobileNumber).val().trim(),
                        input: self.elements.textBox.mobileNumber,
                        message: self.elements.messages.invalidMobileNumber },
                    { value: $(self.elements.textBox.homeNumber).val().trim(),
                        input: self.elements.textBox.homeNumber,
                        message: self.elements.messages.invalidHomeNumber },
                    { value: $(self.elements.textBox.workNumber).val().trim(),
                        input: self.elements.textBox.workNumber,
                        message: self.elements.messages.invalidWorkNumber }
                ];
                const allEmpty = fields.every(field => field.value === '');
                if (allEmpty) {
                    self.func.inValidAllNumberFields();
                    return false;
                }
                let isValid = true;
                fields.forEach(field => {
                    if (field.value !== '' && !self.func.isNumberOnly(field.value)) {
                        $(field.input).addClass(self.css.invalidFormInput);
                        $(field.message).removeClass(self.css.hideElement);
                        isValid = false;
                    }
                });
                return isValid;
            },
            isNumberOnly: function (input){
                return (/^[0-9]{10,11}$/.test(input));
            },
            inValidAllNumberFields: function (){
                $(self.elements.messages.invalidMobileNumber).removeClass(self.css.hideElement);
                $(self.elements.textBox.workNumber).addClass(self.css.invalidFormInput);
                $(self.elements.textBox.mobileNumber).addClass(self.css.invalidFormInput);
                $(self.elements.textBox.homeNumber).addClass(self.css.invalidFormInput);
            },
            onInputClearError: function () {
                const inputFields = [
                    self.elements.textBox.mobileNumber,
                    self.elements.textBox.homeNumber,
                    self.elements.textBox.workNumber
                ];
                const errorMessages = [
                    self.elements.messages.invalidMobileNumber,
                    self.elements.messages.invalidHomeNumber,
                    self.elements.messages.invalidWorkNumber
                ];

                inputFields.forEach(field => {
                    $(field).removeClass(self.css.invalidFormInput);
                });
                errorMessages.forEach(message => {
                    $(message).addClass(self.css.hideElement);
                });
            },
            allowNumbersOnly: function (event) {
                const charCode = event.charCode || event.keyCode;
                const isControlCode = charCode <= self.constants.CharCodeUnitSeparator;
                const isNumericCode = charCode >= self.constants.CharCodeNumericLowerBound &&
                    charCode <= self.constants.CharCodeNumericUpperBound;
                if (!isControlCode && !isNumericCode) {
                    event.preventDefault();
                    return false;
                }
            },
            allowPastingOfNumbers: function (event) {
                event.preventDefault();
                let clipData = event.originalEvent.clipboardData.getData('text');
                if (clipData) {
                    event.target.value = clipData.replace(/[^0-9]/g, '').slice(0, self.constants.InputNumberLength);
                    self.func.onInputClearError();
                }
            },
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('health-telephone-form' === $('#health-telephone-form').data('feature')) {
        window.UpdateHealthContactForm.Init();
    }
});
